module.exports = __webpack_public_path__ + "media/yolo-3.0/asq-8eabb404.svg";